import styled from 'styled-components'
import Flex from 'Components/Flex'
import SvgIcon from 'Components/SvgIcon'

import {
  TEXT_GREY, DOUGHNUT_CHART_COLOR,
} from '@CSSVars/colors'


export const _DoughnutChartCont = styled(Flex)`
  position: relative;
`

export const _CircleEmpty = styled.circle`
  stroke: ${TEXT_GREY};
  fill: none;

  shape-rendering: geometricPrecision;
`

export const _Circle = styled.circle`
  stroke: ${DOUGHNUT_CHART_COLOR};
  fill: none;
  transition: stroke-dashoffset 0.7s;
  transition-delay: 1s;
  transform: rotate(-90deg);
  transform-origin: 50% 50%;
`

export const _MiddleSvg = styled(SvgIcon)`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  fill: ${DOUGHNUT_CHART_COLOR};

  path {
    fill: ${DOUGHNUT_CHART_COLOR};
  }
`
